import React, { useState, useEffect } from "react";
import "./login.css";
import { Link, useLocation, useNavigate} from 'react-router-dom';
import { database } from "../../database/firebase";
import {
  ref,
  push,
  set,
  get,
  orderByChild,
  onChildAdded,
  limitToLast,
  onValue,
  query,
  off,
  update,
} from "firebase/database";
import axios from "axios";
import Swal from 'sweetalert2';

function Login({ updateHeader }) {
  const location = useLocation();
  
  // Use URLSearchParams to access the query parameters
  const queryParams = new URLSearchParams(location.search);
  const getOtp = queryParams.get('otp');
  const role = queryParams.get('role');
  const [otp, setOtp] = useState(getOtp);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // To control login state
  const [themeData, setThemeData] = useState(null);
  const [pollingLogo, SetPollingLogo] = useState("/img/polling-logo.png");
  const [isLogoSet,SetIsLogoSet]=useState(false);
  const navigate = useNavigate();

  const uuid4 = () => {
    // Generates something like 'e3b0c442-98fc-4b1d-a7f3-0d8d9a0a1b1e'
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };


  const handleSuccess = (msg) => {
    Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };

  const handleError = (msg) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: msg,
      customClass: {
        popup: 'custom-success-popup' // Apply your custom class
      }
    });
  };

  const handleLogin = () => {
    if(queryParams.get('save')){
        console.log("ignoring latest update...");
         SetIsLogoSet(true);
    }else if(queryParams.get('demo')){
      const userData = {
        userId: "demo86078205",
        sessionId: "demobypass",
        gameId: "abcd",
        organizationId: "demobypass",
        token: "",
        role:"demobypass",
        name: "demo86078205",
        email: "demo86078205@gmail.com",
        expiry: new Date().getTime() + 24 * 60 * 60 * 1000,
        source: "demobypass"
      };
      console.log(userData);
      sessionStorage.setItem('userData', JSON.stringify(userData));

      const demoSessionId = userData.sessionId;
      const demoUserId = userData.userId;
      const demoOrgId = userData.organizationId;
      const themeUrl = `${process.env.REACT_APP_FETCH_THEMEDATA}?sessionId=${demoSessionId}&userId=${demoUserId}&organizationId=${demoOrgId}`;

      fetch(themeUrl)
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
          return res.json();
        })
        .then((json) => {
          console.log(json);
          sessionStorage.setItem('themeData', JSON.stringify(json));
          setThemeData(json);
        })
        .catch((err) => console.log('Demo theme fetch:', err.message))
        .finally(() => {
          setIsLoggedIn(true);
          SetIsLogoSet(true);
        });
    }else{
      let apiUrl;
      const requestData = { otp: otp };
      let source=null;
  
    
      if (role === 'GUEST_USER') {
        apiUrl = process.env.REACT_APP_FIREBASE_GUEST_USER_API;
        requestData.role = 'GUEST_USER';
        source='GUEST_USER'
      } else {
        apiUrl = process.env.REACT_APP_FIREBASE_LOGIN_API;
        source='ORG_USER'
      }
    
      const headers = {
        'client-secret': process.env.REACT_APP_FIREBASE_CLIENT_SECRET,
        'Content-Type': 'application/json',
        'Idempotency-Key': uuid4(),
      };
    
    
      axios.post(apiUrl, requestData, { headers })
        .then(response => {
          console.log("API TRIGGER");
          if (response.data.message === 'LOGIN SUCCESS') {
            console.log(response.data.data.gameId);
            let finalCompanyLogo=null;
            axios.get(process.env.REACT_APP_ORG_API+"/"+response.data.data.organizationId, {organizationId:response.data.data.organizationId}, { headers })
            .then(responseOrg => {
              if (responseOrg.data.message === 'ORGANIZATIONS_FETCHED_SUCCESSFULLY') {
                  let companyLogo = responseOrg.data.organization.companyLogo;
                  finalCompanyLogo = (companyLogo == null || companyLogo === '')
                    ? process.env.REACT_APP_EM_LOGO
                    : process.env.REACT_APP_S3_SOURCE + companyLogo;
                  updateHeader({
                    imageUrl:finalCompanyLogo,
                    backButtonRedirect: process.env.REACT_APP_BASE_URL+"/game-detail/"+response.data.data.gameId, // New Back Button Target
                  });
              }
              console.log(responseOrg);
            })
            
            const userId = role === 'GUEST_USER' 
              ? response.data.data.id 
              : response.data.data.userId;  
    
              let name = `${response.data.data.firstName || ""} ${response.data.data.lastName || ""}`;
              let email = response.data.data.email;
              console.log("even checking ??",role);
              if (role === 'GUEST_USER' && (response.data.data.firstName === null || response.data.data.firstName === '')) {
       
                if (response.data.data.email) {
                  // Extract the part before '@' in the email (email has priority)
                  name = response.data.data.email.split('@')[0];
                } else if (response.data.data.employeeId) {
                  // Use employeeId as name if email is not present (although email will be present as per your note)
                  name = response.data.data.employeeId;
                  email = response.data.data.employeeId
                } else {
                  name = 'Guest'; // Fallback name if both email and employeeId are unavailable
                }
              }
  
  
              const rawMulti = response.data.data.isMultiplaySession;
              const userData = {
                userId: userId, // userId
                sessionId: response.data.data.sessionId, // response.data.data.sessionId;
                gameId: response.data.data.gameId,
                organizationId: response.data.data.organizationId,
                token: response.data.data.token || "",
                role:source, 
                name: name,
                email: email,
                phoneNumber: response.data.data.userCustomFieldsData?.phoneNumber || null,
                isMultiplaySession:
                  rawMulti === true ||
                  rawMulti === 'true' ||
                  rawMulti === 1 ||
                  rawMulti === '1',
                expiry: new Date().getTime() + 24 * 60 * 60 * 1000, 
                source: source
              };
              console.log(userData);
              sessionStorage.setItem('userData', JSON.stringify(userData));
  
              // Reference to the user's document inside the session's users collection
              // const userDocRef = doc(
              //   database,
              //   `sessions/${userData.sessionId}/users/${userData.userId}`
              // );
                 SetIsLogoSet(true);

              const getData = ref(database, `/users/${userData.userId}`);
              
  
                get(getData)
    .then((snapshot) => {
      if (snapshot.exists()) {
                    setIsLoggedIn(true);
                    SetIsLogoSet(true);
                    console.log("Current user already exists! Ignoring update...");
                    if(queryParams.get('admin')){
                       window.location.href = process.env.REACT_APP_ADMIN_REDIRECT+'?sessionId='+response.data.data.sessionId+"&userId="+userId+"&organizationId="+response.data.data.organizationId+"&gameId="+response.data.data.gameId+"&company_logo="+finalCompanyLogo;
                    }
      } else {
  // If the user doesn't exist, add a new document
                    setIsLoggedIn(true);
                    SetIsLogoSet(true);
                    // setDoc(userDocRef, {
                    //   userId: userData.userId,
                    //   organizationId: userData.organizationId,
                    //   sessionId: userData.sessionId,
                    //   name: userData.name,
                    //   email: userData.email,
                    //   timestamp: Date.now(),
                    //   source: source,
                    // });
                      if(queryParams.get('admin')){
                       window.location.href =process.env.REACT_APP_ADMIN_REDIRECT+'?sessionId='+response.data.data.sessionId+"&userId="+userId+"&organizationId="+response.data.data.organizationId+"&gameId="+response.data.data.gameId+"&company_logo="+finalCompanyLogo;
                      }
                    }
                  

                    if (queryParams.get('admin') === 'true') {
                         console.log("Access denied.");
                    }else{
                      fetch(process.env.REACT_APP_FETCH_THEMEDATA+'?sessionId='+response.data.data.sessionId+"&userId="+userId+"&organizationId="+response.data.data.organizationId) // Replace with your API URL
                      .then((response) => {
                        if (!response.ok) {
                          throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                      })
                      .then((json) => {
                        sessionStorage.setItem('themeData', JSON.stringify(json));
                        setThemeData(json);
                        console.log(json);
                      })
                      .catch((err) => {
                        console.log(err.message); // Handle error
                      });
           }
    })
    .catch((error) => {
 console.error("Error processing user data:", error);
    });
              // // Check if the user already exists
              // getDoc(userDocRef)
              //   .then((userSnapshot) => {
              //     if (userSnapshot.exists()) {
              //       setIsLoggedIn(true);
              //       console.log("Current user already exists! Ignoring update...");
              //       if(queryParams.get('admin')){
              //          window.location.href = process.env.REACT_APP_ADMIN_REDIRECT+'?sessionId='+response.data.data.sessionId+"&userId="+userId+"&organizationId="+response.data.data.organizationId+"&gameId="+response.data.data.gameId+"&company_logo="+finalCompanyLogo;
              //       }
              //     } else {
              //       // If the user doesn't exist, add a new document
              //       setIsLoggedIn(true);
              //       // setDoc(userDocRef, {
              //       //   userId: userData.userId,
              //       //   organizationId: userData.organizationId,
              //       //   sessionId: userData.sessionId,
              //       //   name: userData.name,
              //       //   email: userData.email,
              //       //   timestamp: Date.now(),
              //       //   source: source,
              //       // });
              //         if(queryParams.get('admin')){
              //          window.location.href =process.env.REACT_APP_ADMIN_REDIRECT+'?sessionId='+response.data.data.sessionId+"&userId="+userId+"&organizationId="+response.data.data.organizationId+"&gameId="+response.data.data.gameId+"&company_logo="+finalCompanyLogo;
              //         }
              //       }
                  

              //       if (queryParams.get('admin') === 'true') {
              //            console.log("Access denied.");
              //       }else{
              //         fetch(process.env.REACT_APP_FETCH_THEMEDATA+'?sessionId='+response.data.data.sessionId+"&userId="+userId+"&organizationId="+response.data.data.organizationId) // Replace with your API URL
              //         .then((response) => {
              //           if (!response.ok) {
              //             throw new Error(`HTTP error! status: ${response.status}`);
              //           }
              //           return response.json();
              //         })
              //         .then((json) => {
              //           sessionStorage.setItem('themeData', JSON.stringify(json));
              //           setThemeData(json);
              //           console.log(json);
              //         })
              //         .catch((err) => {
              //           console.log(err.message); // Handle error
              //         });
              //       }
                 
                      
              //   })
              //   .catch((error) => {
              //     handleError("Login failed! Please try again.");
              //     console.error("Error processing user data:", error);
              //   });
          } else {
            handleError('Login failed! Please try again.');
          }
        })
        .catch(error => {
          console.error('Login Failed:', error.response?.data?.err?.message || 'An error occurred');
          handleError('Login failed! Please try again.');
        });
    }
  };

  useEffect(() => {
    // // First-time login
    // const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    // if (storedUserData) {
    //   sessionStorage.removeItem('userData');
    // }
    handleLogin();
  }, []); // Runs once on component mount

  useEffect(()=>{
    if(themeData!=null){
      const body = document.body;
      if (body.classList.contains('common-bg')) {
        body.style.removeProperty('background-image');
        if (themeData.background_desk) {
          body.style.setProperty('--theme-bg-desk', `url(${themeData.background_desk})`);
        }
        if (themeData.background_mob) {
          body.style.setProperty('--theme-bg-mob', `url(${themeData.background_mob})`);
        } else if (themeData.background_desk) {
          body.style.setProperty('--theme-bg-mob', `url(${themeData.background_desk})`);
        }
      }
      if (themeData.text_color) {
        document.documentElement.style.setProperty('--text-color', themeData.text_color);
      }
      SetPollingLogo(themeData.logo);
      SetIsLogoSet(true);
    }
  },[themeData]);


  useEffect(()=>{
    setTimeout(function(){
      if(queryParams.get('save')){
        let getThemeData = sessionStorage.getItem('themeData');
        getThemeData=JSON.parse(getThemeData);
        console.log(getThemeData);
        let body = document.body;
        setIsLoggedIn(true);
        if(getThemeData){
          if (getThemeData.text_color) {
            document.documentElement.style.setProperty('--text-color', getThemeData.text_color);
          }
          if(body.classList.contains('common-bg')) {
            body.style.removeProperty('background-image');
            if (getThemeData.background_desk) {
              body.style.setProperty('--theme-bg-desk', `url(${getThemeData.background_desk})`);
            }
            if (getThemeData.background_mob) {
              body.style.setProperty('--theme-bg-mob', `url(${getThemeData.background_mob})`);
            } else if (getThemeData.background_desk) {
              body.style.setProperty('--theme-bg-mob', `url(${getThemeData.background_desk})`);
            }
            SetPollingLogo(getThemeData.logo);
            SetIsLogoSet(true);
          }else{
            console.log("not able to find common bg");
          }
          console.log("sessioin state updated!");
        }
      }
    },1000);
  },[]);


  return (
    <>
      {
      (isLogoSet) ?   
      <div className="login-main-container" style={{ textAlign: "center"}}>
      <img src="/img/ludo-logo.png" className="login-logo" />
      </div>
      :
      <>
        <div class="loader">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        </div>
      </>
    
      }
      {isLoggedIn ? (
        <div style={{ textAlign: "center" }}>
          <Link to="/rules">
            <img src="/img/begin-play.png" className="begin-play-img" />
          </Link>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default Login;
